import PropTypes from 'prop-types';
import Icon from "../../Display/Icon/Icon";
import Popover from "../../Display/Popover/Popover";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function StatusToolTip(_ref) {
  let {
    description,
    toolTip,
    programId,
    className,
    tooltipPosition
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: `uu-search-popover__${description}-container flex`,
    style: {
      display: 'unset'
    },
    children: /*#__PURE__*/_jsx(Popover, {
      id: `tool-tip-${description}-${programId.replace(/[^a-zA-Z0-9]/g, '-')}`,
      className: `uu-search-popover__${description} pointer-events-none`,
      content: toolTip,
      position: tooltipPosition,
      showArrow: true,
      onClick: e => {
        e.stopPropagation();
      },
      trigger: "click",
      width: "64" // 16rem via 'w-64' property
      ,
      children: /*#__PURE__*/_jsxs("button", {
        id: `tool-tip-button-${programId.replace(/[^a-zA-Z0-9]/g, '-')}`,
        type: "button",
        className: className,
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "QuestionCircleO",
          color: "current-blue"
        }), /*#__PURE__*/_jsx("span", {
          className: "sr-only",
          children: description
        })]
      })
    })
  });
}
StatusToolTip.propTypes = {
  description: PropTypes.string.isRequired,
  toolTip: PropTypes.string.isRequired,
  programId: PropTypes.string.isRequired,
  className: PropTypes.string,
  tooltipPosition: PropTypes.string
};
StatusToolTip.defaultProps = {
  className: null,
  tooltipPosition: 'top'
};
export default StatusToolTip;
//# sourceMappingURL=StatusToolTip.js.map